import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { requestOtp, sendPrecheckinLink, verifyOtp } from '../api';

// export const requestOtpThunk = createAsyncThunk<
// 	any, // return type
// 	{ token: string; email: string } // argument type
// >('otp/requestOtp', async ({ token, email }, { rejectWithValue }) => {
// 	try {
// 		const resp = await requestOtp(token, email);
// 		return resp;
// 	} catch (err: any) {
// 		return rejectWithValue(err.response?.data?.message || 'OTP request failed');
// 	}
// });

export const requestOtpThunk = createAsyncThunk<
	any, // return type
	{ token: string; email: string; profileID?: number } // argument type
>(
	'otp/requestOtp',
	async ({ token, email, profileID }, { rejectWithValue }) => {
		try {
			const resp = await requestOtp(token, email, profileID);

			// Only return the serializable part
			return resp?.data ?? null; // <- ✅ prevents non-serializable warning
		} catch (err: any) {
			return rejectWithValue(
				err.response?.data?.message || 'OTP request failed'
			);
		}
	}
);

export const verifyOtpThunk = createAsyncThunk<
	any, // return email
	{ token: string; email: string; otp: string; profileID?: number }, // argument type
	{ rejectValue: string }
>(
	'otp/verifyOtp',
	async ({ token, email, otp, profileID }, { rejectWithValue }) => {
		try {
			const result = await verifyOtp(token, email, otp, profileID ?? 0);
			return result;
		} catch (err: any) {
			return rejectWithValue(
				err.response?.data?.message || 'OTP verification failed'
			);
		}
	}
);

export const sendPrecheckinLinkThunk = createAsyncThunk<
	any,
	{ token: string; emailModel: any },
	{ rejectValue: string }
>(
	'otp/sendPrecheckinLink',
	async ({ token, emailModel }, { rejectWithValue }) => {
		try {
			const result = await sendPrecheckinLink(token, emailModel);
			console.log('result', result);
			return result?.data ?? true;
		} catch (err: any) {
			return rejectWithValue(
				err.response?.data?.message || 'Email sending failed'
			);
		}
	}
);

const initialState = {
	otp: '',
	loading: false,
	error: '',
	result: null,
};

const otpValidationSlice = createSlice({
	name: 'otpValidation',
	initialState,
	reducers: {
		setOtp: (state, action: any) => {
			state.otp = action.payload;
		},
		clearOtp: (state) => {
			state.otp = '';
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(requestOtpThunk.pending, (state) => {
				state.loading = true;
				state.result = null;
				state.error = '';
			})
			.addCase(requestOtpThunk.fulfilled, (state, action) => {
				state.loading = false;
				state.result = action.payload?.result || false;
			})
			.addCase(requestOtpThunk.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as string;
			})
			.addCase(verifyOtpThunk.pending, (state) => {
				state.loading = true;
				state.result = null;
				state.error = '';
			})
			.addCase(verifyOtpThunk.fulfilled, (state, action) => {
				state.loading = false;
				state.result = action.payload?.result || false;
			})
			.addCase(verifyOtpThunk.rejected, (state, action) => {
				state.loading = false;
				state.error = action.payload as string;
			});
	},
});

export const { setOtp, clearOtp } = otpValidationSlice.actions;
export default otpValidationSlice.reducer;
